<template>
  <div class="goods_model">
    <baseModal
      width="830px"
      title="券包库"
      @sureFun="confirmgoods"
      @cancalFun="couponModelShow = false"
      :dialogVisible="couponModelShow"
    >
      <template #content="scope">
        <baseSearch :list="searchFrom" @search="searchFun"> </baseSearch>
        <baseSelectTable
          ref="baseSelectTable"
          :loading="search.loading"
          :total="search.total"
          :page="search.post.page"
          :pagesize="search.post.limit"
          :list="search.table"
          :tableList="search.tableForm"
          :selection="true"
          @changePage="changePage"
          @tableSelectionChange="tableSelectionChange"
        >
          <!--礼券信息 -->
          <!-- 状态 -->
          <template #status="scope">
            {{scope.row.state==1?'启用':'禁用'}}
          </template>
        </baseSelectTable>
      </template>
    </baseModal>
  </div>
</template>
<script>
import baseSearch from "@/components/common/baseSearch.vue";
import baseSelectTable from "../GoodsModal/baseSelectTable.vue";
import baseModal from "@/components/common/baseModal.vue";
import { eltips } from "@/util/util.js";
import { isRegionScope, resolveWeiShopApi } from "@/views/apps/weishop/region/utils/regionApiMap";
import { appendCurrentRegionStore } from "@/views/apps/weishop/region/mixins/regionPageAdapter";

export default {
	name: 'NewCouponModal',
	// props: {
	//   // 多选模式, 如果false为单选
	//   multiple: true,
	//   // 最大选择的数量限制, multiple模式下有效
	//   maxNum: 100,
	//   // 默认选中的列表记录
	//   defaultList: []
	// },
  components: {
    baseModal,
    baseSearch,
    baseSelectTable,
  },
  data() {
    return {
      search: {
        post: {
          page: 1,
          limit: 10,
        },
        loading: false,
        total: 0,
        tableForm: [
          { label: "券包ID", prop: "id" },
          { label: "券包名称", prop: "name" },
          { label: "券包价格", prop: "price" },
          { label: "库存总量", prop: "stock" },
          { label: "状态", prop: "status", width: 110 },
        ],
        table: [],
      },
      searchFrom: [
        {
          type: "selection",
        },
        {
          type: "input",
          Field: "name",
          label: "券包名称",
          style: {
            width: "130px",
          },
          placeholder: "请输入券包名称",
        },
      ],
      couponModelShow: false,
      selectedItems: [],
      selectedRowKeys: [],
    };
  },
  created() {
    // 获取礼券列表
    this.getGoodsList();
  },
  methods: {
    // 切换页数
    changePage(e) {
      this.search.post.page = e;
      this.getGoodsList();
    },
    // 筛选方法
    searchFun(e) {
      let _this = this;
      _this.search.post.name = e.name;
      this.getGoodsList();
    },
    // 打开礼券库
    handle(data) {
      if (data) {
        this.$nextTick(() => {
          this.$refs.baseSelectTable.updateSelectedMap(data);
        });
        this.$forceUpdate();
      }
      this.couponModelShow = true;
    },
    // 关闭礼券库并返回数据
    handleCancel() {
      this.couponModelShow = false;
    },
    confirmgoods() {
      this.$refs.baseSelectTable.changepage();
      const data = this.$refs.baseSelectTable.getAllSelections();
      this.$emit("handleSubmit", {
        selectedItems: data,
      });

      this.handleCancel();
    },
    // 获取当前被选中礼券的数据
    tableSelectionChange(e) {
      this.selectedItems = e;
    },
    // 礼券列表
    getGoodsList() {
      let _this = this;
      _this.search.loading = true;
      _this.axios
        .get(resolveWeiShopApi("/api/weishop/admin/plugin/couponpack/index"), {
          params: isRegionScope() ? appendCurrentRegionStore({
            ..._this.search.post,
          }) : {
            ..._this.search.post,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            _this.search.table = res.data.data.map((item) => {
              return {
                ...item
              };
            });
            _this.search.total = res.data.total;
          } else {
            eltips(res.msg, "error");
          }
          _this.search.loading = false;
        });
    },
    addIdAsValueToTree(tree) {
      // 递归函数遍历树形结构并修改每个节点
      function transformTree(node) {
        // 给当前节点添加新属性 'value'，其值为 'id'
        node.value = node.category_id;
        node.label = node.name;
        // 如果当前节点有子节点，递归调用 transformTree
        if (node.children) {
          node.children.forEach((child) => transformTree(child));
        }
      }
      // 对每个根节点进行递归操作
      tree.forEach((node) => transformTree(node));

      // 返回修改后的树
      return tree;
    },
  },
};
</script>
<style lang="less" scoped>
.goods_item {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
/deep/.el-table th,
.el-table td {
  padding: 0;
}
/deep/ .el-dialog__body {
  padding: 0 20px !important;
}
/deep/.searchHead484848 {
  padding: 10px 0;
  margin-left: -19px;
}
/deep/.dialog-footer {
  padding-top: 0;
}
/deep/.el-table th > .cell {
  font-weight: 500;
}
/deep/.dialog-footer {
  padding-top: 10px;
}
</style>
